import { useContext } from 'react';
import { Message, MessageContent } from '@/components/ai-elements/message';
import { Button } from '@/components/ui/button';
import type { AskUserAnswerView } from '../chat-conversation-items';
import { ChatToolInteractionContext } from '../chat-tool-interaction';
import {
  USER_MESSAGE_CONTENT_CLASS,
  USER_MESSAGE_ROOT_CLASS,
  USER_MESSAGE_TEXT_CLASS,
} from './message-bubble-styles';
import './ask-user.css';

type AskUserAnswerBubbleProps = {
  answer: AskUserAnswerView;
  /** Fondu d'apparition : seulement quand la réponse vient d'être donnée, pas à la relecture de l'historique. */
  animate?: boolean;
};

/**
 * Réponse à une question `ask_user`, au même style que les messages utilisateur.
 * Si l'envoi de la continuation a échoué, « Réessayer l'envoi » reste proposé
 * sous la bulle.
 */
export function AskUserAnswerBubble({ answer, animate = false }: AskUserAnswerBubbleProps) {
  const interaction = useContext(ChatToolInteractionContext);
  const hasContinuationError = interaction?.toolContinuationError?.toolCallId === answer.toolCallId;

  return (
    <Message
      from="user"
      className={USER_MESSAGE_ROOT_CLASS}
      data-testid="ask-user-answer"
    >
      <MessageContent className={animate ? `${USER_MESSAGE_CONTENT_CLASS} t-ask-answer` : USER_MESSAGE_CONTENT_CLASS}>
        <div className="flex flex-col gap-3.5">
          <p className={USER_MESSAGE_TEXT_CLASS}>
            <span className="sr-only">Votre réponse : </span>
            {answer.text}
          </p>
        </div>
      </MessageContent>
      {hasContinuationError ? (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="mt-2 h-8 w-fit self-end rounded-full border-border/70 px-3.5 text-xs shadow-none"
          onClick={interaction?.retryAskUserContinuation}
        >
          Réessayer l’envoi
        </Button>
      ) : null}
    </Message>
  );
}
